<template>
  <v-app>
    <!-- react to emergency take down of the site -->
    <emergency-down v-if="isAppDown" />

    <!-- spinner -->
    <spinner />

    <!-- vuetify container -->
    <!-- add special background image for default destination login page -->
    <v-container
      class="pt-0 px-0 container--fluid"
      :class="{ 'login-background': $route.name === 'login' }"
    >
      <!-- menu header -->
      <app-header-admin ref="skinowHeader" class="z-index-7" />
      <!-- vuetify grid -->
      <v-row class="no-gutters">
        <!-- width depending whether it's backend view or not -->
        <v-col class="col-12">
          <!-- notification section -->
          <v-row>
            <notification />
          </v-row>

          <!-- backend side menu -->
          <backend-side-menu
            v-if="
              $route.name !== 'login' &&
              $route.name !== 'profile' &&
              $route.name !== 'noAccess'
            "
          />

          <!-- T1-708 overlapping drawer -->
          <v-content class="sidebarOffset">
            <!-- spacer for BACKEND -->
            <div class="header-menu-bottom-level"></div>

            <!-- router view -->
            <router-view class="wrap" />
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import AppHeaderAdmin from './components-shared/menus/AppHeaderAdmin'
import Spinner from './components-shared/utils/Spinner.vue'
import AppDestination from './classes-shared/destinations/AppDestination'
import BackendSideMenu from './components-shared/menus/BackendSideMenu'
import LanguageInjector from './i18n/LanguageInjector'
import EmergencyDown from './components-shared/views/utils/EmergencyDown'
import Notification from './components-shared/utils/Notification'

export default {
  name: 'App',

  components: {
    EmergencyDown,
    BackendSideMenu,
    AppHeaderAdmin,
    Spinner,
    Notification,
  },

  data() {
    return {
      lockPageObserver: false,
      translationsLoaded: false,
      isWarningTextShown: false,
    }
  },

  computed: {
    isAppDown() {
      return process.env.VUE_APP_EMERGENCY_DOWN === 'true'
    },
    watchCurrentDestinationInstance() {
      return this.$store.getters.getCurrentDestinationInstance()
    },
  },

  watch: {
    async watchCurrentDestinationInstance(destinationInstance) {
      // fix 09.04.2020: just load
      if (
        destinationInstance.getSlug() !== 'default' &&
        !this.translationsLoaded
      ) {
        this.translationsLoaded = true
        // inject translations from pe api
        LanguageInjector.injectAllLanguages()
      }
    },
  },

  beforeMount() {
    // loading the destination instance
    const appDestinationInstance = new AppDestination({
      $vuetify: this.$vuetify,
    })
    this.$store.commit('setAppDestinationInstance', appDestinationInstance)

    // set current destination instance => this destination can change
    this.$store.commit('setCurrentDestinationInstance', appDestinationInstance)
  },
}
</script>

<style lang="scss">
$warn-text-info: 70px;

.warning-text-box {
  height: $warn-text-info;
}

.footer-min-height {
  min-height: calc(100vh - #{$image-header-space} - 100px);
}

.app-px {
  padding-left: 5% !important;
  padding-right: 5% !important;
}

@media screen and (max-width: $lg) {
  .app-px {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}

/* outdated browser */
.buorg {
  background-color: white !important;
  bottom: 0;
}

.buorg div {
  text-align: center;
  padding-top: calc(50vh - 150px) !important;
  font-size: $headline-large;
}

// buttons
#buorgig {
  background-color: var(--v-grey-base) !important;
}

#buorgul {
  background-color: var(--v-primary-base);
}

.v-alert__dismissible {
  margin-top: -10px;
}

.v-application {
  padding-bottom: 0px;
}

.sidebarOffset {
  padding-left: 75px !important;
}

.container {
  padding-bottom: 0px;
}

// T1-708 overlapping drawer
.admin-backend-content-padding {
  padding-left: $admin-backend-content-padding !important;
}
</style>
